// Main page for Completed New tasks
import React, { useRef, useState } from 'react';
import { useTrackPageVisitEvent } from 'shared/hooks/use-track-page-visit-event';
import { PageEvents } from 'shared/services/tracking';
import { FilterDocument } from 'shared/types/filter-document';

import * as Styled from './completed.style';
import { PageTopBar } from './components/page-top-bar/index';
import { TasksOverview } from './components/tasks-overview/index';
import { defaultFilter } from './constants';

export const Completed: React.FC = () => {
  useTrackPageVisitEvent(PageEvents.Completed, undefined);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [filterDocument, setFilterDocument] =
    useState<FilterDocument>(defaultFilter);

  return (
    <Styled.Container>
      <Styled.Main>
        <Styled.MainContent>
          <PageTopBar
            filterDocument={filterDocument}
            setFilterDocument={setFilterDocument}
          />
          <Styled.Content ref={scrollContainerRef}>
            <TasksOverview
              scrollElement={scrollContainerRef}
              filterDocument={filterDocument}
              setFilterDocument={setFilterDocument}
            />
          </Styled.Content>
        </Styled.MainContent>
      </Styled.Main>
    </Styled.Container>
  );
};
